"use client";

import { ArrowRight, Car, MapPin, Clock, ShieldCheck, Calendar, Users, Star, Phone } from "lucide-react";
import { Link } from "@/components/common/Link";
import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
export default function Services() {
  const header = useRevealOnScroll<HTMLDivElement>();
  const services = [];
  return;
}
function ServiceCard({
  index,
  code,
  Icon,
  title,
  description,
  duration,
  ...rest
}: {
  index: number;
  code: string;
  Icon: React.ComponentType<{
    className?: string;
    strokeWidth?: number;
  }>;
  title: string;
  description: string;
  duration: string;
  "data-index"?: number;
}) {
  const reveal = useRevealOnScroll<HTMLDivElement>();
  const delay = index % 3 * 100;
  return <div {...rest} ref={reveal.ref} className={`group relative bg-white/5 backdrop-blur-md border border-muted p-8 md:p-10 rounded-lg transition-all duration-500 ease-out hover:border-primary hover:shadow-lg hover:-translate-y-2 hover:scale-[1.02] ${reveal.isVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-10"}`} style={{
    transitionDelay: reveal.isVisible ? `${delay}ms` : "0ms"
  }}>
      

      
    </div>;
}